<template>
  <!-- 首页 -->
  <div class="index">
    <div class="content">
      <cpt-header></cpt-header>
      <div class="home-banner">
        <img class="back" src="../../assets/home-bg1-en.png" v-if="$i18n.locale == 'en-US'" alt="">
        <img class="back" src="../../assets/home-bg1.png" v-else alt="">
      </div>
      <cpt-welcome></cpt-welcome>
      <cpt-unlock></cpt-unlock>
      <cpt-credit></cpt-credit>
      <cpt-new></cpt-new>
      <!-- <div v-if="userAgent">移动端</div> -->
      <cpt-bottom></cpt-bottom>
    </div>
    <cpt-change-lang></cpt-change-lang>
  </div>
</template>

<script>
import cptHeader from '../../components/header/cpt-header.vue';
import cptBottom from '../../components/cpt-bottom.vue';
import cptWelcome from '../../components/cpt-welcome.vue';
import cptUnlock from '../../components/cpt-unlock.vue';
import cptCredit from '../../components/cpt-credit.vue';
// import cptNew from '../../components/cpt-new.vue';
import cptChangeLang from '../../components/cpt-change-lang.vue';
export default {
  components: {
    cptHeader,
    cptBottom,
    cptWelcome,
    cptUnlock,
    cptCredit,
    // cptNew,
    cptChangeLang
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.index {
  width: auto;
  display: flex;
  justify-content: center;
  .content {
    width: 100%;
    .home-banner{
      width: 100%;
      display: flex;
      .back{
        width: 100%;
        min-height: 175px;
      }
    }
  }
  .el-header,
  .el-footer {
    // background-color: #b3c0d1;
    color: #333;
    text-align: center;
    // line-height: 60px;
  }
  .el-main {
    background-color: #e9eef3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
}
</style>